import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';
import { FootnotesPipe, RouterLinkDirective, TrackingDirective } from '@hyundai/ng-common-lib';
import { M010C020IconLinkComponent } from '../../010-buttons-and-links/m010-c020-icon-link/m010-c020-icon-link.component';

@Component({
    selector: 'ui-m040-c045-offer-banner',
    standalone: true,
    templateUrl: './m040-c045-offer-banner.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [M010C020IconLinkComponent, RouterLinkDirective, FootnotesPipe, TrackingDirective],
})
export class M040C045OfferBannerComponent {
    data = input<Array<{ label: string; value: string; unit: string; link?: string; linkText?: string }>>();

    primaryButton = input.required<string>();
    primaryButtonText = input.required<string>();
}
